export default (state, action) => {
  switch (action.type) {
    case 'update_account_info': {
      // Build the mapped account info object
      const mappedAccountInfo = {
        ...state.accountInfo,
        developerId: action?.payload?.id,
        name: action?.payload?.name,
        title: action?.payload?.title,
        email: action?.payload?.email,
        companyName: action?.payload?.companyName,
        sfContactId: action?.payload?.sfContactId,
        account: {
          sfAccountId: action?.payload?.account?.sfAccountId,
          name: action?.payload?.account?.name,
          ein: action?.payload?.account?.ein,
        },
      }

      // Save the MAPPED data to sessionStorage
      sessionStorage.setItem('fsDevPortalAccountInfo', JSON.stringify(mappedAccountInfo))

      // Store cisId if provided
      if (action?.payload?.cisUserId) {
        sessionStorage.setItem('fsDevPortalCisId', action?.payload?.cisUserId)
      }

      return {
        ...state,
        accountInfo: mappedAccountInfo,
      }
    }
    case 'set_all_applications':
      sessionStorage.setItem(
        'fsDevPortalApplications',
        JSON.stringify(action?.payload.map((application) => [`${application.id}`, application]))
      )
      return {
        ...state,
        applications: new Map(action?.payload.map((application) => [`${application.id}`, application])),
      }
    case 'add_new_application':
      sessionStorage.setItem(
        'fsDevPortalApplications',
        JSON.stringify([...state.applications, [`${action?.id}`, action?.payload]])
      )
      return {
        ...state,
        applications: new Map([...state.applications.entries(), [`${action?.id}`, action?.payload]]),
        fetchApplicationsAgain: !state.fetchApplicationsAgain, // Toggle this value to trigger a re-fetch of applications in the ApplicationsOverview component
      }
    case 'update_application':
      sessionStorage.setItem('fsDevPortalApplications', JSON.stringify([...action.payload.entries()]))
      return {
        ...state,
        applications: action?.payload,
      }
    case 'delete_application':
      sessionStorage.setItem('fsDevPortalApplications', JSON.stringify([...action.payload.entries()]))
      return {
        ...state,
        applications: action?.payload,
      }
    case 'add_new_redirect':
      sessionStorage.setItem('fsDevPortalApplications', JSON.stringify([...action.payload.entries()]))
      return {
        ...state,
        applications: action?.payload,
      }
    case 'update_redirect':
      sessionStorage.setItem('fsDevPortalApplications', JSON.stringify([...action.payload.entries()]))
      return {
        ...state,
        applications: action?.payload,
      }
    case 'delete_redirect':
      sessionStorage.setItem('fsDevPortalApplications', JSON.stringify([...action.payload.entries()]))
      return {
        ...state,
        applications: action?.payload,
      }
    case 'clear_session_cache':
      sessionStorage.removeItem('fsDevPortalAccountInfo')
      sessionStorage.removeItem('fsDevPortalApplications')
      sessionStorage.removeItem('fsDevPortalCisId')
      return {
        ...state,
        accountInfo: {},
        applications: new Map(),
        hasFetchedApplications: false,
      }
    case 'clear_account_info_cache':
      sessionStorage.removeItem('fsDevPortalAccountInfo')
      return {
        ...state,
        accountInfo: {},
      }
    case 'clear_applications_cache':
      sessionStorage.removeItem('fsDevPortalApplications')
      return {
        ...state,
        applications: new Map(),
        hasFetchedApplications: false,
      }
    case 'set_has_fetched_applications':
      return {
        ...state,
        hasFetchedApplications: action.payload,
      }
    case 'reset_fetch_applications_again':
      return {
        ...state,
        fetchApplicationsAgain: false,
      }
    case 'set_admin_developer_data':
      sessionStorage.setItem('fsDevPortalAdminData', JSON.stringify(action.payload))
      return {
        ...state,
        adminDeveloperData: action.payload,
      }
    default:
      return state
  }
}
